import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import React from 'react';
import { orderBy } from 'lodash-es';
import { CpsFacetValue } from '@cs-cms/types';

interface GridColumnMenuCheckboxFilterWrapperProps extends GridColumnMenuProps {
  field: string;
  fieldFacets: CpsFacetValue[];
  expanded?: boolean;
  onExpandChange: (nextExpandState: boolean) => void;
}

export const GridColumnMenuCheckboxFilterWrapper: React.FC<GridColumnMenuCheckboxFilterWrapperProps> = props => {
  const { field, fieldFacets, expanded, onExpandChange } = props;
  const data = orderBy(
    fieldFacets.map(facet => ({ [field]: facet.value })),
    [field]
  );

  return (
    <GridColumnMenuCheckboxFilter
      column={props.column}
      filter={props.filter}
      filterOperators={props.filterOperators}
      onFilterChange={props.onFilterChange}
      onCloseMenu={props.onCloseMenu}
      data={data}
      expanded={expanded}
      onExpandChange={onExpandChange}
      searchBoxFilterOperator={'contains'}
    />
  );
};
